export const BRAND_IDS = {
    TOKYO: 'tokyo',
    BAHROMA: 'bahroma',
}

export const BRAND_PRIORITY = [BRAND_IDS.TOKYO, BRAND_IDS.BAHROMA]
